import api from "./apiToken";

class FilterService {
  getFilterProduct(data) {
    return api.post("/getFilterProduct", data);
  }
}

export default new FilterService();
